// extracted by mini-css-extract-plugin
export default {"noHorizontalPadding":"IconButton_noHorizontalPadding__tYKPR"};